import { Mapper } from "../../../../core/base";
import { AuthorizeWebEntity } from "./authorize.web-entity";
import { Authorize } from "../../../../core/domain/models";

export class AuthorizeWebRepositoryMapper extends Mapper<AuthorizeWebEntity, Authorize> {
  mapFrom(param: AuthorizeWebEntity): Authorize {
    return {
      token: param.token,
      username: param.username,
      email: param.email,
      roles: param.roles,
      tenantId: param.tenantId
    };
  }

  mapTo(param: Authorize): AuthorizeWebEntity {
    return {
      token: param.token,
      username: param.username,
      email: param.email,
      roles: param.roles,
      tenantId: param.tenantId
    };
  }

}
